import { get } from './P3Api';

class CategoryGroupCommodityVarietyApi {
  static async getCategoryGroupCommodityVarieties(categoryId, groupId, commodityId) {
    return get(`categories/${categoryId}/groups/${groupId}/commodities/${commodityId}/varieties`);
  }
}

export default CategoryGroupCommodityVarietyApi;
